import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography, TextButton, Card, styled, generateId } from 'bonfire-kindling';

const StyledTextButton = styled(TextButton)(() => ({
  fontWeight: 'bold',
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const SavedSearchSettingsListItem = ({ name }) => {
  const { t } = useTranslation();

  const id = useMemo(() => generateId(), []);

  return (
    <Card component="li" sx={{ display: 'inline-flex', alignItems: 'center', p: 4 }}>
      <Typography id={id} component="p" variant="body2" sx={{ flex: '1 1 0%', mr: 1 }}>
        {name}
      </Typography>
      <StyledTextButton
        component={RouterLink}
        label={t('settings.saved_search.overview.edit_saved_search')}
        variant="text"
        to="*"
        aria-describedby={id}
      />
      <StyledTextButton
        label={t('settings.saved_search.overview.remove_saved_search')}
        variant="text"
        aria-describedby={id}
      />
    </Card>
  );
};

export default SavedSearchSettingsListItem;
